// extracted by mini-css-extract-plugin
export default {"container":"CardMaquina_container__Ii54M","btn":"CardMaquina_btn__n5s4c"};